import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MarketoPreferencesResult } from '@frk/eds-components/lib/models/marketo-form.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserPreferencesService {
  constructor(private http: HttpClient) {}

  getEmailPreferences$(emailId: string): Observable<MarketoPreferencesResult> {
    const emailPreferencesList = [
      'subInternalAdvisorConsultantUpdates',
      'subSeniorAdvisorConsultantUpdates',
      'subEvents',
      'subWeeklyMarketUpdates',
      'subMonthlyInvestmentSummary',
      'subAdministrativeNotices',
      'subAllocationViews',
      'subEquities',
      'subCapitalMarketsDesk',
      'subFixedIncome',
      'subGIOandCIOViews',
      'subGlobalMacroViews',
      'subHedgeFundStrategyOutlook',
      'subYieldUpdates',
      'subModelPortfolioAllocationChanges',
      'subAnatomyofaRecession',
      'subFranklinIncomeInvestors',
      'subClearBridge',
      'subClarionPartners',
      'subBrandywine',
      'subFTInvestmentInstitute',
      'subRoyce',
      'subRetirement',
      'subWesternAsset',
      'subAlternatives',
      'subBenefitStreetPartners',
      'subLexingtonPartners',
      'subDigitalAssets',
      'subPutnam',
      'subRIAAction',
      'subCanvas',
      'subCryptoMonitor',
    ];
    const emailPrefrencesString = emailPreferencesList.join(',');
    const url = `/api/marketolead?fields=${emailPrefrencesString}&filterValues=${emailId}`;
    return this.http.get<MarketoPreferencesResult>(url);
  }
}
